import dynamic from "next/dynamic";

export const ServicesList = dynamic(() => import("./component"));
